import gql from 'graphql-tag';

export const getEvents = gql`
  query ($minisite: Int) {
    getEvents(minisite: $minisite) {
      eventId
      beacon {
        deviceId
      }
	    minisite {
        minisiteId
      }
	    start
	    end
	    recursive
      serialRangeStart
      serialRangeEnd
    }
  }
`
